module.exports = "/static-assets/feed-ui/_next/static/images/SuperheroFreak-c99fff4d17155a311b3c19964514a2ed.png";